export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8732.bf4e678d.jpg";